"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var color_1 = __importDefault(require("color"));
var material_kit_pro_react_1 = require("../../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a, _b, _c;
    return (0, core_1.makeStyles)({
        root: __assign(__assign({}, material_kit_pro_react_1.container), { display: 'flex', flex: 1, flexDirection: 'column' }),
        header: (_a = {
                width: '100%',
                paddingLeft: theme.spacing(2),
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2)
            },
            _a[theme.breakpoints.down('sm')] = {
                paddingLeft: theme.spacing(1)
            },
            _a),
        headerText: {
            color: theme.palette.text.secondary
        },
        nested: {
            paddingLeft: theme.spacing(4)
        },
        button: (_b = {
                marginTop: theme.spacing(4),
                marginBottom: theme.spacing(4),
                paddingTop: 10,
                paddingBottom: 10,
                textAlign: 'center',
                display: 'flex',
                alignContent: 'center'
            },
            _b[theme.breakpoints.up('md')] = {
                paddingLeft: theme.spacing(5),
                paddingRight: theme.spacing(5),
                marginLeft: theme.spacing(3)
            },
            _b[theme.breakpoints.down('xs')] = {
                paddingLeft: theme.spacing(10),
                paddingRight: theme.spacing(10)
            },
            _b[theme.breakpoints.down('xs')] = {
                width: '100%',
                maxWidth: '91%'
            },
            _b),
        groupItem: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing() / 2
        },
        item: {
            paddingTop: theme.spacing() + 4
        },
        groupDivider: {
            backgroundColor: (0, color_1.default)(theme.palette.common.black)
                .alpha(0.4)
                .rgb()
                .string()
        },
        formControl: (_c = {
                minWidth: 200,
                marginRight: theme.spacing(4)
            },
            _c[theme.breakpoints.down('xs')] = {
                minWidth: 120,
                marginRight: theme.spacing(1)
            },
            _c['& div'] = {
                padding: theme.spacing(1)
            },
            _c),
        cssDiv: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: 24,
            height: 24,
            borderRadius: '50%',
            padding: 2
        },
        contentWrap: {
            width: '100%'
        },
        buttonWrap: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map